import React, { useState, useMemo, useEffect } from "react";
import { IoIosArrowDropdown } from "react-icons/io";
import { RiResetLeftLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getMonthAbbreviation } from "../../../Utilitie";

const BlockDataFilter = ({
  data,
  setDataForTable,
  activeReportPage,
  setFilteredData,
  openStates,
  setOpenStates,
}) => {
  // State for search inputs
  const [fromTime, setFromTime] = useState("18:30");
  const [toTime, setToTime] = useState("06:30");
  const [timeFilter, setTimeFilter] = useState(false);
  const [searchValues, setSearchValues] = useState({
    Year: "",
    Months: "",
    Dates: "",
    Section: "",
    "To Station": "",
    "From Station": "",
    Department: "",
    Type: "",
    "Block Type": "",
    "Granted/Not": "",
    "Availed/Not": "",
    Burst: "",
    Corridore: "",
    Direction: "",
    Rolling_Block: "",
    Reason: "",
  });

  // State for selected filters
  const [selectedYear, setSelectedYear] = useState(new Set());
  const [selectedMonth, setSelectedMonth] = useState(new Set());
  const [selectedDate, setSelectedDate] = useState(new Set());
  const [selectedSection, setSelectedSection] = useState(new Set());
  const [selectedFromStation, setSelectedFromStation] = useState(new Set());
  const [selectedToStation, setSelectedToStation] = useState(new Set());
  const [selectedDepartment, setSelectedDepartment] = useState(new Set());
  const [selectedType, setSelectedType] = useState(new Set());
  const [selectedBlockType, setSelectedBlockType] = useState(new Set());
  const [selectedGrantedNot, setSelectedGrantedNot] = useState(new Set());
  const [selectedAvailedNot, setSelectedAvailedNot] = useState(new Set());
  const [selectedBurst, setSelectedBurst] = useState(new Set());
  const [selectedCorridore, setSelectedCorridore] = useState(new Set());
  const [selectedDirection, setSelectedDirection] = useState(new Set());
  const [selectedRollingBlock, setSelectedRollingBlock] = useState(new Set());
  const [selectedReason, setSelectedReason] = useState(new Set());
  useEffect(() => {
    setTimeFilter(false);
  }, [activeReportPage]);
  useEffect(() => {
    setDataForTable({
      section: Array.from(selectedSection),
      month: Array.from(selectedMonth),
      department: Array.from(selectedDepartment),
      type: Array.from(selectedType),
      blockType: Array.from(selectedBlockType),
      grantedNot: Array.from(selectedGrantedNot),
      AvailedNot: Array.from(selectedAvailedNot),
      direction: Array.from(selectedDirection),
      corridor: Array.from(selectedReason),
    });
  }, [selectedSection]);

  const toggleSelection = (setFunc, currentSet, value) => {
    const newSet = new Set(currentSet);
    newSet.has(value) ? newSet.delete(value) : newSet.add(value);
    setFunc(newSet);
  };

  const toggleDropdown = (title) => {
    setOpenStates((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleSearchChange = (title, value) => {
    setSearchValues((prev) => ({
      ...prev,
      [title]: value,
    }));
  };
  // Initialize filter options
  const defaultSetup = () => {
    if (!data?.length) return;
    const allYears = [
      ...new Set(
        data.map((y) => y.reportDate?.slice(0, 4)).filter((v) => v != null),
      ),
    ];
    const allMonth = [
      ...new Set(
        data.map((d) => d.reportDate?.slice(5, 7)).filter((v) => v != null),
      ),
    ];
    const allDates = [
      ...new Set(
        data.map((d) => d.reportDate?.slice(0, 10)).filter((v) => v != null),
      ),
    ];

    const allSection = [
      ...new Set(data.map((d) => d.section).filter((v) => v != null)),
    ];
    const allFromStation = [
      ...new Set(data.map((fs) => fs.From_Station).filter((v) => v != null)),
    ];
    const allToStation = [
      ...new Set(data.map((ts) => ts.To_Station).filter((v) => v != null)),
    ];

    const allDepartment =
      activeReportPage === "Machine (Eng)"
        ? ["ENGINEERING", "OHE", "OHE_CONST"]
        : activeReportPage === "COM ENGG Position"
          ? ["ENGINEERING", "CONST_ENGINEERING", "IRCON_ENGG"]
          : [
              ...new Set(
                data.map((d) => d.Department).filter((v) => v != null),
              ),
            ];
    const allType =
      activeReportPage === "Machine (Eng)"
        ? ["MACHINE", "POWER_TRAFFIC", "POWER"]
        : activeReportPage === "COM ENGG Position"
          ? ["MACHINE", "POWER_TRAFFIC", "POWER"]
          : activeReportPage === "Section Wise Block"
            ? ["MACHINE", "OTHERS"]
            : [...new Set(data.map((d) => d.Type).filter((v) => v != null))];

    const allBlockType = [
      ...new Set(data.map((d) => d.Block_Type).filter((v) => v != null)),
    ];
    // const allGrantedNot = [
    //   ...new Set(data.map((d) => d.Granted_Not).filter((v) => v != null)),
    // ];
    const allGrantedNot = [
      ...new Set(data.map((d) => d.Granted_Not).filter((v) => v != null)),
    ];
    const allAvailedNot = [
      ...new Set(data.map((d) => d.Availed_Not).filter((v) => v != null)),
    ];
    const allBurst = [
      ...new Set(data.map((d) => d.Burst).filter((v) => v != null)),
    ];
    const allCorridore = [
      ...new Set(data.map((d) => d.Corridore).filter((v) => v != null)),
    ];
    const allDirection = [
      ...new Set(data.map((d) => d.Direction).filter((v) => v != null)),
    ];
    const allRollingBlock = [
      ...new Set(data.map((d) => d.Rolling_Block).filter((v) => v != null)),
    ];
    const allReason = [
      ...new Set(data.map((d) => d.Reason).filter((v) => v != null)),
    ];
    setSelectedYear(new Set(allYears));
    setSelectedMonth(new Set(allMonth));
    setSelectedDate(new Set(allDates));
    setSelectedSection(new Set(allSection));
    setSelectedToStation(new Set(allToStation));
    setSelectedFromStation(new Set(allFromStation));
    setSelectedDepartment(new Set(allDepartment));
    setSelectedType(new Set(allType));
    setSelectedBlockType(new Set(allBlockType));
    setSelectedGrantedNot(new Set(allGrantedNot));
    setSelectedAvailedNot(new Set(allAvailedNot));
    setSelectedBurst(new Set(allBurst));
    setSelectedCorridore(new Set(allCorridore));
    setSelectedDirection(new Set(allDirection));
    setSelectedRollingBlock(new Set(allRollingBlock));
    setSelectedReason(new Set(allReason));
    setSearchValues({
      Year: "",
      Months: "",
      Dates: "",
      "To Station": "",
      "From Station": "",
      Section: "",
      Department: "",
      Type: "",
      "Block Type": "",
      "Granted/Not": "",
      "Availed/Not": "",
      Burst: "",
      Corridore: "",
      Direction: "",
      Rolling_Block: "",
      Reason: "",
    });
    setOpenStates({
      Year: false,
      Month: false,
      Dates: false,
      Section: false,
      "To Station": false,
      "From Station": false,
      Department: false,
      Type: false,
      "Block Type": false,
      "Granted/Not": false,
      "Availed/Not": false,
      Burst: false,
      Corridore: false,
      Direction: false,
      Rolling_Block: false,
      Reason: false,
      "Time Slot": false,
    });
    setTimeFilter(false);
  };

  useEffect(() => {
    defaultSetup();
  }, [data]);
  // Available options for each filter
  const availableYear = useMemo(() => {
    return [
      ...new Set(
        data.map((y) => y.reportDate?.slice(0, 4)).filter((v) => v != null),
      ),
    ];
  }, [data]);

  const availableMonths = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter((entry) => selectedYear.has(entry.reportDate?.slice(0, 4)))
          .map((m) => m.reportDate?.slice(5, 7))
          .filter((v) => v != null),
      ),
    ];
  }, [data, selectedYear]);
  const availableDates = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)),
          )
          .map((d) => d.reportDate?.slice(0, 10))
          .filter((v) => v != null),
      ),
    ];
  }, [data, selectedYear, selectedMonth]);
  const availableSection = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)),
          )
          .map((d) => d.section)
          .filter((v) => v != null),
      ),
    ];
  }, [data, selectedYear, selectedMonth, selectedDate]);
  const availableFromStation = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section),
          )
          .map((d) => d.From_Station)
          .filter((v) => v != null),
      ),
    ];
  }, [data, selectedYear, selectedMonth, selectedDate]);
  const availableToStation = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station),
          )
          .map((d) => d.To_Station)
          .filter((v) => v != null),
      ),
    ];
  }, [data, selectedYear, selectedMonth, selectedDate, selectedFromStation]);
  const availableDirection = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station),
          )
          .map((d) => d.Direction)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
  ]);

  const availableDepartment = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction),
          )
          .map((d) => d.Department)
          .filter((v) =>
            activeReportPage === "COM ENGG Position"
              ? (v === "ENGINEERING" ||
                  v === "CONST_ENGINEERING" ||
                  v === "IRCON_ENGG") &&
                v != null
              : v != null,
          ),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
  ]);
  const availableType = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department),
          )
          .map((d) => d.Type)
          .filter((v) =>
            activeReportPage === "COM ENGG Position"
              ? v === "MACHINE" && v != null
              : v != null,
          ),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
  ]);
  const availableBlockType = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type),
          )
          .map((d) => d.Block_Type)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
  ]);

  const availableGrantedNot = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type),
          )
          .map((d) => d.Granted_Not)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
  ]);
  const availableAvailedNot = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type) &&
              selectedGrantedNot.has(entry.Granted_Not),
          )
          .map((d) => d.Availed_Not)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
  ]);

  const availableBurst = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type) &&
              selectedGrantedNot.has(entry.Granted_Not) &&
              selectedAvailedNot.has(entry.Availed_Not),
          )
          .map((d) => d.Burst)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
    selectedAvailedNot,
  ]);

  const availableCorridore = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type) &&
              selectedGrantedNot.has(entry.Granted_Not) &&
              selectedAvailedNot.has(entry.Availed_Not) &&
              selectedBurst.has(entry.Burst),
          )
          .map((d) => d.Corridore)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
    selectedAvailedNot,
    selectedBurst,
  ]);

  const availableRollingBlock = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type) &&
              selectedGrantedNot.has(entry.Granted_Not) &&
              selectedAvailedNot.has(entry.Availed_Not) &&
              selectedBurst.has(entry.Burst) &&
              selectedCorridore.has(entry.Corridore),
          )
          .map((d) => d.Rolling_Block)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
    selectedAvailedNot,
    selectedBurst,
    selectedCorridore,
  ]);
  const availableReason = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedYear.has(entry.reportDate?.slice(0, 4)) &&
              selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
              selectedDate.has(entry.reportDate?.slice(0, 10)) &&
              selectedSection.has(entry.section) &&
              selectedFromStation.has(entry.From_Station) &&
              selectedToStation.has(entry.To_Station) &&
              selectedDirection.has(entry.Direction) &&
              selectedDepartment.has(entry.Department) &&
              selectedType.has(entry.Type) &&
              selectedBlockType.has(entry.Block_Type) &&
              selectedGrantedNot.has(entry.Granted_Not) &&
              selectedAvailedNot.has(entry.Availed_Not) &&
              selectedBurst.has(entry.Burst) &&
              selectedCorridore.has(entry.Corridore) &&
              selectedRollingBlock.has(entry.Rolling_Block),
          )
          .map((d) => d.Reason)
          .filter((v) => v != null),
      ),
    ];
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    availableToStation,
    selectedDirection,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
    selectedAvailedNot,
    selectedBurst,
    selectedCorridore,
    selectedRollingBlock,
  ]);

  // Filtered data based on selections
  const filteredData = useMemo(() => {
    if (
      !data ||
      !Array.isArray(data) ||
      selectedYear.size === 0 ||
      selectedMonth.size === 0 ||
      selectedDate.size === 0 ||
      selectedSection.size === 0 ||
      selectedDepartment.size === 0 ||
      selectedType.size === 0 ||
      selectedBlockType.size === 0 ||
      selectedGrantedNot.size === 0 ||
      selectedAvailedNot.size === 0 ||
      selectedBurst.size === 0 ||
      selectedCorridore.size === 0 ||
      selectedDirection.size === 0 ||
      selectedRollingBlock.size === 0 ||
      selectedReason === 0
    ) {
      return [];
    }

    return data.filter((entry) => {
      return (
        selectedYear.has(entry.reportDate?.slice(0, 4)) &&
        selectedMonth.has(entry.reportDate?.slice(5, 7)) &&
        selectedDate.has(entry.reportDate?.slice(0, 10)) &&
        selectedSection.has(entry.section) &&
        selectedFromStation.has(entry.From_Station) &&
        selectedToStation.has(entry.To_Station) &&
        selectedDepartment.has(entry.Department) &&
        selectedType.has(entry.Type) &&
        selectedBlockType.has(entry.Block_Type) &&
        selectedGrantedNot.has(entry.Granted_Not) &&
        selectedAvailedNot.has(entry.Availed_Not) &&
        selectedBurst.has(entry.Burst) &&
        selectedCorridore.has(entry.Corridore) &&
        selectedDirection.has(entry.Direction) &&
        selectedRollingBlock.has(entry.Rolling_Block) &&
        selectedReason.has(entry.Reason)
      );
    });
  }, [
    data,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedSection,
    selectedFromStation,
    selectedToStation,
    selectedDepartment,
    selectedType,
    selectedBlockType,
    selectedGrantedNot,
    selectedAvailedNot,
    selectedBurst,
    selectedCorridore,
    selectedDirection,
    selectedRollingBlock,
    selectedReason,
  ]);
  // Propagate filteredData to parent component
  useEffect(() => {
    if (!timeFilter) {
      setFilteredData(filteredData); // use base data
      return;
    }

    const from = Number(fromTime?.replace(":", ""));
    const to = Number(toTime?.replace(":", ""));
    const timeWiseFD = filteredData
      .filter((o) => o.Granted_Duration !== "00:00:00")
      .filter((o) => {
        const start = Number(o.GrantedFrom.replace(":", "").slice(0, 4));
        const end = Number(o.GrantedTo.replace(":", "").slice(0, 4));
        if (from <= to) {
          return start >= from && start <= to && end <= to && end >= start;
        } else {
          return (start >= from && end >= from) || (end <= to && end <= from);
        }
      });
    setFilteredData(timeWiseFD);
  }, [filteredData, fromTime, toTime, timeFilter]);
  const renderCheckboxList = (title, items, selectedSet, setFunc) => {
    // console.log(title === "Year" && { items, selectedSet });
    const filteredItems = items.filter((item) =>
      item
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchValues[title]?.toLowerCase() || ""),
    );

    return (
      <div className="col-md mt-2 p-1">
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white shadow-sm"
          style={{
            position: "relative",
            fontSize: 12,
            borderRadius: "8px",
          }}
        >
          {/* Filter Header */}
          <div
            onClick={() => toggleDropdown(title)}
            className="papaDiv d-flex align-items-center justify-content-between"
            style={{
              // background: "linear-gradient(135deg, #fa7979 0%, #7c4848 100%)",
              // color: "#fff",
              border: "none",
              padding: "8px 10px",
              cursor: "pointer",
              minWidth: "150px",
              maxHeight: "44px",
              overflow: "hidden",
              userSelect: "none",
              borderRadius: "7px",
              boxShadow: "0 2px 5px rgba(6, 59, 135, 0.14)",
            }}
          >
            <span
              className="text-truncate"
              style={{
                fontWeight: 600,
                letterSpacing: "0.1px",
              }}
            >
              Select {title}
            </span>

            <IoIosArrowDropdown
              style={{
                fontSize: 16,
                minWidth: "16px",
                marginLeft: "6px",
                opacity: 0.9,
                transition: "transform 0.3s ease",
                transform: openStates[title]
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            />
          </div>

          {/* Dropdown */}
          {openStates[title] && (
            <div
              className="papaDiv shadow-sm"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #d7e2ef",
                background: "#ffffff",
                zIndex: 1000,
                borderRadius: "0 0 8px 8px",
                overflow: "hidden",
              }}
            >
              {/* Dropdown Heading */}
              <div
                className="fw-semibold px-2 py-2"
                style={{
                  background: "#eef5ff",
                  color: "#063b87",
                  borderBottom: "1px solid #dbe7f4",
                }}
              >
                {title === "Time Slot" ? `(Granted) ${title}` : title}
              </div>

              {title === "Time Slot" ? (
                <div className="p-2">
                  {/* Time Filter */}
                  <div className="form-check mb-3">
                    <input
                      id={`time-filter-${title}`}
                      type="checkbox"
                      className="form-check-input"
                      checked={timeFilter}
                      onChange={() => setTimeFilter((prev) => !prev)}
                      style={{
                        accentColor: "#0a57bb",
                      }}
                    />

                    <label
                      htmlFor={`time-filter-${title}`}
                      className="form-check-label fw-semibold"
                      style={{
                        color: "#29415f",
                      }}
                    >
                      Enable Time Filter
                    </label>
                  </div>

                  {/* From / To */}
                  <div className="row g-2">
                    <div className="col-6">
                      <label
                        className="fw-semibold mb-1"
                        style={{
                          color: "#58708e",
                          fontSize: "11px",
                        }}
                      >
                        FROM
                      </label>

                      <input
                        type="time"
                        value={fromTime}
                        onChange={(e) => setFromTime(e.target.value)}
                        className="form-control form-control-sm"
                        style={{
                          borderColor: "#c8d8eb",
                          background: "#fff",
                        }}
                      />
                    </div>

                    <div className="col-6">
                      <label
                        className="fw-semibold mb-1"
                        style={{
                          color: "#58708e",
                          fontSize: "11px",
                        }}
                      >
                        TO
                      </label>

                      <input
                        type="time"
                        value={toTime}
                        onChange={(e) => setToTime(e.target.value)}
                        className="form-control form-control-sm"
                        style={{
                          borderColor: "#c8d8eb",
                          background: "#fff",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  {/* Search */}
                  <div className="p-2">
                    <input
                      style={{
                        height: "30px",
                        width: "100%",
                        borderColor: "#c8d8eb",
                        background: "#fff",
                        borderRadius: "5px",
                      }}
                      className="form-control form-control-sm"
                      type="search"
                      placeholder={`Search ${title}...`}
                      aria-label={`Search ${title}`}
                      value={searchValues[title] || ""}
                      onChange={(e) =>
                        handleSearchChange(title, e.target.value)
                      }
                    />
                  </div>

                  <hr
                    className="m-0"
                    style={{
                      borderColor: "#e1eaf5",
                    }}
                  />

                  {/* Suggestions */}
                  <div
                    className="suggestion  py-1"
                    key={filteredItems.length}
                    style={{
                      maxHeight: "250px",
                      minHeight: "50px",
                      overflowY: "auto",
                    }}
                  >
                    {filteredItems.length > 0 ? (
                      filteredItems.map((item, index) => (
                        <div
                          key={index}
                          className="fade-in"
                          style={{
                            fontSize: "12px",
                            minWidth: "150px",
                          }}
                        >
                          <label
                            className="d-flex align-items-center gap-2 px-2 py-1 mb-0"
                            style={{
                              cursor: "pointer",
                              color: "#243b53",
                              borderRadius: "4px",
                            }}
                          >
                            <input
                              className="form-check-input mt-0"
                              type="checkbox"
                              checked={selectedSet.has(item)}
                              onChange={() =>
                                toggleSelection(setFunc, selectedSet, item)
                              }
                              style={{
                                accentColor: "#0a57bb",
                              }}
                            />

                            <span className="text-truncate">
                              {title === "Months"
                                ? getMonthAbbreviation(item)
                                : item || "N/A"}
                            </span>
                          </label>
                        </div>
                      ))
                    ) : (
                      <div
                        className="text-center py-3"
                        style={{
                          color: "#71839a",
                        }}
                      >
                        No items found
                      </div>
                    )}
                  </div>

                  <hr
                    className="m-0"
                    style={{
                      borderColor: "#e1eaf5",
                    }}
                  />

                  {/* Actions */}
                  <div className="d-flex gap-2 p-2">
                    <button
                      className="btn btn-sm flex-fill fw-semibold text-white"
                      style={{
                        background:
                          "linear-gradient(135deg, #063b87 0%, #0a57bb 100%)",
                        border: "none",
                        borderRadius: "5px",
                      }}
                      onClick={() => setFunc(new Set(filteredItems))}
                    >
                      Select All
                    </button>

                    <button
                      className="btn btn-sm flex-fill fw-semibold"
                      style={{
                        color: "#063b87",
                        background: "#eef5ff",
                        border: "1px solid #c8d8eb",
                        borderRadius: "5px",
                      }}
                      onClick={() => setFunc(new Set())}
                    >
                      Clear All
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="papaDiv">
      <div
        className="row"
        style={{
          border: "1px solid #d7e2ef",
          background: "#f7faff",
          borderRadius: "12px",
          padding: "6px",
          boxShadow: "0 4px 16px rgba(6, 59, 135, 0.08)",
        }}
      >
        {activeReportPage === "Block Reports" &&
          renderCheckboxList(
            "Year",
            availableYear,
            selectedYear,
            setSelectedYear,
          )}
        {(activeReportPage === "Block Reports" ||
          activeReportPage === "Machine (Eng)") &&
          renderCheckboxList(
            "Months",
            availableMonths,
            selectedMonth,
            setSelectedMonth,
          )}{" "}
        {activeReportPage === "Block Reports" &&
          renderCheckboxList(
            "Dates",
            availableDates,
            selectedDate,
            setSelectedDate,
          )}
        {renderCheckboxList(
          "Section",
          availableSection,
          selectedSection,
          setSelectedSection,
        )}
        {renderCheckboxList(
          "From Station",
          availableFromStation,
          selectedFromStation,
          setSelectedFromStation,
        )}
        {renderCheckboxList(
          "To Station",
          availableToStation,
          selectedToStation,
          setSelectedToStation,
        )}
        {renderCheckboxList(
          "Direction",
          availableDirection,
          selectedDirection,
          setSelectedDirection,
        )}
        {activeReportPage !== "Machine (Eng)" &&
          renderCheckboxList(
            "Department",
            availableDepartment,
            selectedDepartment,
            setSelectedDepartment,
          )}
        {activeReportPage !== "Machine (Eng)" &&
          activeReportPage !== "Material Train Report" &&
          renderCheckboxList(
            "Type",
            availableType,
            selectedType,
            setSelectedType,
          )}
        {activeReportPage !== "Material Train Report" &&
          renderCheckboxList(
            "Block Type",
            availableBlockType,
            selectedBlockType,
            setSelectedBlockType,
          )}
        {renderCheckboxList(
          "Granted/Not",
          availableGrantedNot,
          selectedGrantedNot,
          setSelectedGrantedNot,
        )}
        {activeReportPage !== "Block Position" &&
          renderCheckboxList(
            "Availed/Not",
            availableAvailedNot,
            selectedAvailedNot,
            setSelectedAvailedNot,
          )}
        {renderCheckboxList(
          "Burst",
          availableBurst,
          selectedBurst,
          setSelectedBurst,
        )}
        {renderCheckboxList(
          "Corridor",
          availableCorridore,
          selectedCorridore,
          setSelectedCorridore,
        )}
        {renderCheckboxList(
          "Rolling Block",
          availableRollingBlock,
          selectedRollingBlock,
          setSelectedRollingBlock,
        )}
        {(activeReportPage === "Custom Report" ||
          activeReportPage === "Block Not Availed") &&
          renderCheckboxList(
            "Reason",
            availableReason,
            selectedReason,
            setSelectedReason,
          )}
        {renderCheckboxList(
          "Time Slot",
          availableRollingBlock,
          selectedRollingBlock,
          setTimeFilter,
        )}
        <OverlayTrigger
          delay={{ show: 100, hide: 200 }}
          overlay={<Tooltip id="tooltip-reset">Reset Filter</Tooltip>}
        >
          <div
            className="btn btn-sm d-flex justify-content-center align-items-center mt-1 mb-1"
            style={{
              maxWidth: "35px",
              minHeight: "32px",
              color: "#fcfcfc",
              border: "1px solid #c8d8eb",
              borderRadius: "7px",
              background:
                "linear-gradient(135deg, #bb0a0a 0%, #bb0a0a 50%, #870606 100%)",
              boxShadow: "3px 3px 10px rgba(6, 59, 135, 0.18)",
            }}
            onClick={defaultSetup}
          >
            <RiResetLeftLine
              style={{
                fontSize: "15px",
                fontWeight: "bold",
              }}
            />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default React.memo(BlockDataFilter);
